module.exports = __webpack_public_path__ + "img/careers_ricerca.42798008.png";